import { useMemo } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import { validations } from 'utils/validation'

import { Href } from 'components/ui'
import { Links, TokenSubLinks } from 'constants/link'

type LinkProps = {
  url: string
  title: string
  end?: boolean
}

const TOKENS_LINKS: string[] = [Links.HOME, Links.TOKEN, TokenSubLinks.APPROVAL, TokenSubLinks.AIRDROP]

const CustomLink = ({ title, url, end = true }: LinkProps) => {
  const location = useLocation()

  // ToDo think about
  const isTokenAirdrop = useMemo(() => {
    return TOKENS_LINKS.includes(location.pathname) && url === Links.TOKEN
  }, [location.pathname, url])

  const isExternalLink = useMemo(() => validations.externalLink(url), [url])
  const isActive = useMemo(() => location.pathname === url || isTokenAirdrop, [location.pathname, url, isTokenAirdrop])

  const className = useMemo(() => (isActive ? 'activeNavLink' : undefined), [isActive])

  return (
    <>
      {isExternalLink ? (
        <Href href={url}>{title}</Href>
      ) : (
        <NavLink to={url} end={end} caseSensitive className={className}>
          {title}
        </NavLink>
      )}
    </>
  )
}

export { CustomLink }
